var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('button',{staticClass:"button yellow_bord submitbutton",class:{'is-warning': this.isLoading, 'is-loading': this.isLoading},attrs:{"disabled":this.isLoading,"type":"submit"},on:{"click":_vm.refreshToon}},[_vm._v("Refresh Toon\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }